import { io } from "socket.io-client";

let currentUserId = null;
// const SOCKET_URL = "http://localhost:9009";
const SOCKET_URL = "https://netfee.top";

const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  path: "/nf.wss",
  autoConnect: false,
});

export const connectSocket = (userId) => {
  if (!socket.connected) {
    currentUserId = userId;

    socket.connect();
    socket.emit("joinUser", userId);
  }
};

export const disconnectSocket = () => {
  if (socket.connected && currentUserId) {
    socket.emit("leaveUser", currentUserId);
    socket.disconnect();

    currentUserId = null;
  }
};

// Clean up on browser close
window.addEventListener("beforeunload", () => {
  disconnectSocket();
});

export default socket;
